export const serviceProjectSchema = {
  type: "object",
  properties: {
    name: {
      title: "The name for the project",
      type: "string",
    },
    domain: {
      title: "The domain name (optional).",
      type: "string",
      default: "",
    },
    activate_apis: {
      title: "The list of apis to activate within the project",
      type: "array",
      items: {
        type: "string",
      },
      default: [
        "compute.googleapis.com",
        "container.googleapis.com",
        "dataflow.googleapis.com",
        "bigquery.googleapis.com",
      ],
    },
    shared_vpc_subnets: {
      type: "array",
      title: "List of host subnet ids and regions",
      items: {
        type: "object",
        properties: {
          subnet_id: {
            title: "subnet ID",
            type: "string",
          },
          region: {
            title: "Subnet Region",
            type: "string",
          },
        },
      },
    },
    labels: {
      type: "array",
      title: "Map of labels for project",
      items: {
        type: "object",
        properties: {
          key: {
            type: "string",
          },
          value: {
            type: "string",
          },
        },
      },
    },
    lien: {
      type: "boolean",
      title: "Add a lien on the project to prevent accidental deletion",
      default: true,
    },
  },
  required: ["name"],
};
